export const CHAT_COLLAPSED_RAIL_WIDTH = '2.25rem';

export type ChatLayoutFlags = {
  readonly chatMaximized: boolean;
  readonly chatCollapsed: boolean;
};

export function toggleChatMaximized(current: ChatLayoutFlags): ChatLayoutFlags {
  const chatMaximized = !current.chatMaximized;
  return {
    chatMaximized,
    chatCollapsed: chatMaximized ? false : current.chatCollapsed,
  };
}

export function toggleChatCollapsed(current: ChatLayoutFlags): ChatLayoutFlags {
  const chatCollapsed = !current.chatCollapsed;
  return {
    chatCollapsed,
    chatMaximized: chatCollapsed ? false : current.chatMaximized,
  };
}
